
import { createRoot } from 'react-dom/client'; // New import for React 18
import App from './App';
import { AppStateProvider } from './hooks/useAppState';

const container = document.getElementById('root');
const root = createRoot(container); // Create a root.

root.render(
  <AppStateProvider>
    <App />
  </AppStateProvider>
);
